export enum InputType {
  text = 'text',
  email = 'email',
  search = 'search',
  number = 'number',
  password = 'password'
}
